import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/qyhzimg1.png'
import _imports_1 from '@/assets/image/qyhzliucheng1.png'
import _imports_2 from '@/assets/image/sthzjiantou.png'
import _imports_3 from '@/assets/image/qyhzliucheng2.png'
import _imports_4 from '@/assets/image/qyhzliucheng3.png'
import _imports_5 from '@/assets/image/qyhzliucheng4.png'
import _imports_6 from '@/assets/image/qyhzliucheng5.png'
import _imports_7 from '@/assets/image/qyhzliucheng6.png'
import _imports_8 from '@/assets/image/sjsliucheng.png'
import _imports_9 from '@/assets/image/qyhzimg2.png'
import _imports_10 from '@/assets/image/zhichi1.png'
import _imports_11 from '@/assets/image/zhichi2.png'
import _imports_12 from '@/assets/image/zhichi3.png'
import _imports_13 from '@/assets/image/duigou.png'


const _withScopeId = n => (_pushScopeId("data-v-2aa95b00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scheme" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div style=\"position:relative;\" data-v-2aa95b00></div><div class=\"banner container\" data-v-2aa95b00><p data-v-2aa95b00>自动化设计方案-合作伙伴</p><div data-v-2aa95b00></div></div><div class=\"pattern container\" data-v-2aa95b00><div class=\"title1\" data-v-2aa95b00>合作模式</div><div class=\"yellow\" data-v-2aa95b00></div><div class=\"pattern1\" data-v-2aa95b00><div class=\"img\" data-v-2aa95b00><img src=\"" + _imports_0 + "\" alt=\"\" data-v-2aa95b00></div><div class=\"right\" data-v-2aa95b00><div class=\"one\" data-v-2aa95b00><div class=\"blue\" data-v-2aa95b00></div><p data-v-2aa95b00>企业合作</p></div><div class=\"two\" data-v-2aa95b00><div class=\"course-box\" data-v-2aa95b00><div class=\"liucheng\" style=\"width:104px;\" data-v-2aa95b00><img src=\"" + _imports_1 + "\" alt=\"\" data-v-2aa95b00><div data-v-2aa95b00>注册设纪元</div></div><img src=\"" + _imports_2 + "\" alt=\"\" class=\"jiantou\" data-v-2aa95b00><div class=\"liucheng\" data-v-2aa95b00><img src=\"" + _imports_3 + "\" alt=\"\" data-v-2aa95b00><div data-v-2aa95b00>完成企业认证</div></div><img src=\"" + _imports_2 + "\" alt=\"\" class=\"jiantou\" data-v-2aa95b00><div class=\"liucheng\" data-v-2aa95b00><img src=\"" + _imports_4 + "\" alt=\"\" data-v-2aa95b00><div data-v-2aa95b00>达成合作协议</div></div><img src=\"" + _imports_2 + "\" alt=\"\" class=\"jiantou\" data-v-2aa95b00><div class=\"liucheng\" data-v-2aa95b00><img src=\"" + _imports_5 + "\" alt=\"\" data-v-2aa95b00><div data-v-2aa95b00>提交设计方案</div></div><img src=\"" + _imports_2 + "\" alt=\"\" class=\"jiantou\" data-v-2aa95b00><div class=\"liucheng\" style=\"width:104px;\" data-v-2aa95b00><img src=\"" + _imports_6 + "\" alt=\"\" data-v-2aa95b00><div data-v-2aa95b00>设纪元审核整理并上传</div></div><img src=\"" + _imports_2 + "\" alt=\"\" class=\"jiantou\" data-v-2aa95b00><div class=\"liucheng\" data-v-2aa95b00><img src=\"" + _imports_7 + "\" alt=\"\" data-v-2aa95b00><div data-v-2aa95b00>企业获得分成</div></div></div></div></div></div><div class=\"pattern2\" data-v-2aa95b00><div class=\"right\" data-v-2aa95b00><div class=\"one\" data-v-2aa95b00><div class=\"blue\" data-v-2aa95b00></div><p data-v-2aa95b00>设计师合作</p></div><div class=\"two\" data-v-2aa95b00><div class=\"course-box\" data-v-2aa95b00><div class=\"liucheng\" style=\"width:104px;\" data-v-2aa95b00><img src=\"" + _imports_1 + "\" alt=\"\" data-v-2aa95b00><div data-v-2aa95b00>注册设纪元</div></div><img src=\"" + _imports_2 + "\" alt=\"\" class=\"jiantou\" data-v-2aa95b00><div class=\"liucheng\" data-v-2aa95b00><img src=\"" + _imports_8 + "\" alt=\"\" data-v-2aa95b00><div data-v-2aa95b00>完成个人认证</div></div><img src=\"" + _imports_2 + "\" alt=\"\" class=\"jiantou\" data-v-2aa95b00><div class=\"liucheng\" data-v-2aa95b00><img src=\"" + _imports_5 + "\" alt=\"\" data-v-2aa95b00><div data-v-2aa95b00>上传设计方案</div></div><img src=\"" + _imports_2 + "\" alt=\"\" class=\"jiantou\" data-v-2aa95b00><div class=\"liucheng\" style=\"width:104px;\" data-v-2aa95b00><img src=\"" + _imports_6 + "\" alt=\"\" data-v-2aa95b00><div data-v-2aa95b00>设纪元审核整理并上传</div></div><img src=\"" + _imports_2 + "\" alt=\"\" class=\"jiantou\" data-v-2aa95b00><div class=\"liucheng\" style=\"width:140px;\" data-v-2aa95b00><img src=\"" + _imports_7 + "\" alt=\"\" data-v-2aa95b00><div data-v-2aa95b00>设计师获得收益</div></div></div></div></div><div class=\"img\" data-v-2aa95b00><img src=\"" + _imports_9 + "\" alt=\"\" data-v-2aa95b00></div></div></div><div class=\"support container\" data-v-2aa95b00><div class=\"back\" data-v-2aa95b00></div><div class=\"title1\" data-v-2aa95b00>合作支持</div><div class=\"yellow\" data-v-2aa95b00></div><div class=\"one container\" data-v-2aa95b00><div class=\"box\" data-v-2aa95b00><img src=\"" + _imports_10 + "\" alt=\"\" data-v-2aa95b00><p data-v-2aa95b00>海量资料</p><div style=\"width:322px;margin-left:23px;line-height:26px;\" data-v-2aa95b00> 工业自动化行业专属资料库,提供丰富设计方案，助力团队效能升级 </div></div><div class=\"box\" data-v-2aa95b00><img src=\"" + _imports_11 + "\" alt=\"\" data-v-2aa95b00><p data-v-2aa95b00>安全保障</p><div style=\"width:246px;margin-left:60px;line-height:26px;\" data-v-2aa95b00> 全站设计资料均有加密,保障合作伙伴利益 </div></div><div class=\"box\" data-v-2aa95b00><img src=\"" + _imports_12 + "\" alt=\"\" data-v-2aa95b00><p data-v-2aa95b00>专业团队</p><div data-v-2aa95b00>拥有一批专业的技术人员和工程师</div></div></div></div>", 4)
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "earnings container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title1" }, "合作权益"),
  /*#__PURE__*/_createElementVNode("div", { class: "yellow" }),
  /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
    /*#__PURE__*/_createElementVNode("table", { style: {"width":"auto"} }, [
      /*#__PURE__*/_createElementVNode("tbody", null, [
        /*#__PURE__*/_createElementVNode("tr", { class: "row1" }, [
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "2",
            rowSpan: "1",
            width: "508"
          }, [
            /*#__PURE__*/_createTextVNode("权益类型"),
            /*#__PURE__*/_createElementVNode("br")
          ]),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "729"
          }, "权益说明"),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "202"
          }, "企业"),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "202"
          }, "设计师")
        ]),
        /*#__PURE__*/_createElementVNode("tr", { class: "row2" }, [
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "3",
            class: "fuwu"
          }, [
            /*#__PURE__*/_createElementVNode("div", null, [
              /*#__PURE__*/_createElementVNode("p", null, "基础服务")
            ])
          ]),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "325"
          }, "资料审核、整理"),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, " 由设纪元专业的机械工程师审核和整理资料 "),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_13,
              alt: ""
            })
          ]),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_13,
              alt: ""
            })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", {
          class: "row2",
          style: {"background":"#fff"}
        }, [
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "325"
          }, "品牌推广"),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, " 专属个人/企业主页，打造您的线上设计方案作品集 "),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_13,
              alt: ""
            })
          ]),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_13,
              alt: ""
            })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", { class: "row2" }, [
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "325"
          }, "设计方案推广"),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, " 由设纪元专业机械工程师上架设计方案 "),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_13,
              alt: ""
            })
          ]),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_13,
              alt: ""
            })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", {
          class: "row2",
          style: {"background":"#fff"}
        }, [
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto",
            style: {"background":"#fff"}
          }, " 线上推广 "),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "325"
          }, "营销活动"),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, "参与平台线上营销活动"),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_13,
              alt: ""
            })
          ]),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_13,
              alt: ""
            })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", { class: "row2" }, [
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "2",
            width: "auto",
            style: {"background":"#fff"},
            class: "shouyi"
          }, [
            /*#__PURE__*/_createElementVNode("div", null, "收益模式")
          ]),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "325"
          }, "上传作品获得收益"),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, " 上传作品后依据评估标准获得收益 "),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_13,
              alt: ""
            })
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", {
          class: "row",
          style: {"background":"#fff"}
        }, [
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "325"
          }, "上传作品获得分成"),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, " 上传作品后按照比例获得分成 "),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_13,
              alt: ""
            }),
            /*#__PURE__*/_createElementVNode("td", {
              colSpan: "1",
              rowSpan: "1",
              width: "auto"
            })
          ]),
          /*#__PURE__*/_createElementVNode("td", {
            colSpan: "1",
            rowSpan: "1",
            width: "auto"
          })
        ])
      ])
    ])
  ])
], -1))
const _hoisted_7 = { class: "join1 container" }
const _hoisted_8 = { class: "join" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "routine" }, "立即加入", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_html_footer = _resolveComponent("html-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_home_head),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, { to: { name: 'verify', params: {
          type: 1,
        }, } }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_html_footer)
  ], 64))
}